export const MENU = [
  {
    id: "hot",
    label: "Hot Coffees",
    arabic: "القهوة الساخنة",
    note: "Sizes — R 9oz · L 12oz",
    noteAr: "الأحجام — عادي 9 أونصة · كبير 12 أونصة",
    items: [
      { name: "Espresso", ar: "إسبريسو", price: "0.800 / 0.990", sizes: "Sig / Dbl" },
      { name: "Cortado", ar: "كورتادو", price: "0.990" },
      { name: "Macchiato", ar: "ماكياتو", price: "0.990" },
      { name: "Americano", ar: "أمريكانو", price: "0.990 / 1.300", sizes: "R / L" },
      { name: "Long Black", ar: "لونغ بلاك", price: "0.990 / 1.300", sizes: "R / L" },
      { name: "Flat White", ar: "فلات وايت", price: "1.200" },
      { name: "Cappuccino", ar: "كابتشينو", price: "1.200 / 1.500", sizes: "R / L" },
      { name: "Café Latte", ar: "كافيه لاتيه", price: "1.200 / 1.500", sizes: "R / L" },
      { name: "Spanish Latte", ar: "سبانيش لاتيه", price: "1.350 / 1.600", sizes: "R / L", pick: true },
      { name: "Hot Mocha — Dark / White", ar: "موكا ساخنة — دارك / وايت", price: "1.700" },
    ],
  },
  {
    id: "signature",
    label: "Signature",
    arabic: "القهوة المميزة",
    note: "Hot / Iced / Iced Blend — 9oz 1.500 · 12oz 1.900 · 16oz 2.200",
    noteAr: "ساخن / مثلج / مثلج مخفوق — 9 أونصة 1.500 · 12 أونصة 1.900 · 16 أونصة 2.200",
    items: [
      { name: "Signature Spanish Latte", ar: "سبانيش لاتيه مميز", price: "1.500 / 1.900 / 2.200", sizes: "9 / 12 / 16oz", pick: true },
      { name: "Cinnamon Punch Latte", ar: "لاتيه بنش القرفة", price: "1.500 / 1.900 / 2.200", sizes: "9 / 12 / 16oz", pick: true },
      { name: "Sea Salt Cinnamon Latte", ar: "لاتيه القرفة بملح البحر", price: "1.500 / 1.900 / 2.200", sizes: "9 / 12 / 16oz" },
      { name: "Tiramisu Latte", ar: "لاتيه تيراميسو", price: "1.500 / 1.900 / 2.200", sizes: "9 / 12 / 16oz" },
      { name: "Cheesecake Latte", ar: "لاتيه تشيز كيك", price: "1.500 / 1.900 / 2.200", sizes: "9 / 12 / 16oz", pick: true },
    ],
  },
  {
    id: "cold",
    label: "Cold & Flavored",
    arabic: "الباردة والمنكّهة",
    note: "Flavored: Vanilla · Hazelnut · Caramel · Salted Caramel (hot / iced / iced blend) — 1.350 / 1.500 / 1.900. Milk options: Almond, Coconut, Oat, Lactose-free, Low-fat (+0.300 R · +0.500 L)",
    noteAr: "منكّهة: فانيلا · بندق · كراميل · كراميل مملح (ساخن / مثلج / مخفوق) — 1.350 / 1.500 / 1.900. خيارات الحليب: لوز، جوز هند، شوفان، خالٍ من اللاكتوز، قليل الدسم (+0.300 عادي · +0.500 كبير)",
    items: [
      { name: "Iced Americano", ar: "أمريكانو مثلج", price: "0.990 / 1.300", sizes: "L / XL" },
      { name: "Iced Long Black", ar: "لونغ بلاك مثلج", price: "0.990 / 1.300", sizes: "L / XL" },
      { name: "Iced Cappuccino", ar: "كابتشينو مثلج", price: "1.200 / 1.500", sizes: "L / XL" },
      { name: "Iced Café Latte", ar: "كافيه لاتيه مثلج", price: "1.200 / 1.500", sizes: "L / XL" },
      { name: "Iced Spanish Latte", ar: "سبانيش لاتيه مثلج", price: "1.350 / 1.600", sizes: "L / XL", pick: true },
      { name: "Iced Mocha — Dark / White", ar: "موكا مثلجة — دارك / وايت", price: "1.700 / 1.950", sizes: "L / XL" },
      { name: "Flavored Latte", ar: "لاتيه منكّه", desc: "Vanilla, hazelnut, caramel or salted caramel — hot, iced or blended", descAr: "فانيلا، بندق، كراميل أو كراميل مملح — ساخن، مثلج أو مخفوق", price: "1.350 / 1.900", sizes: "R / XL" },
    ],
  },
  {
    id: "v60",
    label: "V60 Brews",
    arabic: "قهوة V60",
    note: "Hot / Iced — L 12oz · XL 16oz",
    noteAr: "ساخن / مثلج — كبير 12 أونصة · كبير جداً 16 أونصة",
    items: [
      { name: "Yemen", ar: "يمني", price: "0.990 / 1.300", sizes: "L / XL", pick: true },
      { name: "Brazilian", ar: "برازيلي", price: "0.990 / 1.300", sizes: "L / XL" },
      { name: "Colombian", ar: "كولومبي", price: "0.990 / 1.300", sizes: "L / XL" },
      { name: "Ethiopian", ar: "إثيوبي", price: "0.990 / 1.300", sizes: "L / XL" },
      { name: "Costa Rica", ar: "كوستاريكا", price: "0.990 / 1.300", sizes: "L / XL" },
      { name: "Guatemala", ar: "غواتيمالا", price: "0.990 / 1.300", sizes: "L / XL" },
    ],
  },
  {
    id: "matcha",
    label: "Matcha & Ice Teas",
    arabic: "ماتشا وشاي مثلج",
    note: "Matcha — Green / Blue, hot or iced",
    noteAr: "ماتشا — أخضر / أزرق، ساخن أو مثلج",
    items: [
      { name: "Sipsation Matcha", ar: "ماتشا سبسيشن", price: "1.800", pick: true },
      { name: "Classic Matcha", ar: "ماتشا كلاسيك", price: "1.600" },
      { name: "Velvet Matcha", ar: "ماتشا مخملية", price: "1.600" },
      { name: "Caffeine Matcha", ar: "ماتشا بالكافيين", price: "1.750" },
      { name: "Strawberry Matcha", ar: "ماتشا فراولة", price: "1.750" },
      { name: "Blueberry Matcha", ar: "ماتشا توت أزرق", price: "1.750" },
      { name: "Passion Fruit Ice Tea", ar: "شاي مثلج باشن فروت", desc: "with honeysuckle", descAr: "مع زهرة العسل", price: "1.500 / 1.700", sizes: "L / XL" },
      { name: "Peach Ice Tea", ar: "شاي مثلج بالخوخ", price: "1.500 / 1.700", sizes: "L / XL" },
    ],
  },
  {
    id: "mojitos",
    label: "Mojitos",
    arabic: "موهيتو",
    note: "L 12oz · XL 16oz",
    noteAr: "كبير 12 أونصة · كبير جداً 16 أونصة",
    items: [
      { name: "Sipsation Rainbow", ar: "موهيتو قوس قزح", price: "1.800 / 2.400", sizes: "L / XL", pick: true },
      { name: "Sunset", ar: "موهيتو الغروب", price: "1.800 / 2.400", sizes: "L / XL" },
      { name: "Piña Colada", ar: "بينا كولادا", price: "1.500 / 2.000", sizes: "L / XL" },
      { name: "Passion Fruit", ar: "باشن فروت", price: "1.100 / 1.500", sizes: "L / XL" },
      { name: "Blue Lagoon", ar: "بلو لاغون", price: "1.100 / 1.500", sizes: "L / XL" },
      { name: "Classic Lemonade", ar: "ليمونادة كلاسيك", price: "1.100 / 1.500", sizes: "L / XL" },
      { name: "Classic Mojito", ar: "موهيتو كلاسيك", price: "1.100 / 1.500", sizes: "L / XL" },
      { name: "Strawberry", ar: "موهيتو فراولة", price: "1.100 / 1.500", sizes: "L / XL" },
      { name: "Watermelon", ar: "موهيتو بطيخ", price: "1.100 / 2.400", sizes: "L / XL" },
      { name: "MYC — Make Your Choice", ar: "اصنع اختيارك", price: "1.500 / 2.000", sizes: "L / XL" },
    ],
  },
  {
    id: "breakfast",
    label: "Breakfast & Bakery",
    arabic: "الفطور والمخبوزات",
    note: "Breakfast all day — freshly baked every day",
    noteAr: "فطور طوال اليوم — مخبوزات طازجة يومياً",
    items: [
      { name: "Turkish Labneh Honey", ar: "لبنة تركية بالعسل", price: "1.650 / 2.200", sizes: "Croissant / Waffle" },
      { name: "Turkish Labneh Za'atar", ar: "لبنة تركية بالزعتر", price: "1.650 / 2.200", sizes: "Croissant / Waffle" },
      { name: "Turkish Labneh Za'atar with Honey", ar: "لبنة تركية بالزعتر والعسل", price: "1.900 / 2.500", sizes: "Croissant / Waffle", pick: true },
      { name: "Butter Croissant", ar: "كرواسون زبدة", price: "0.750" },
      { name: "Almond Croissant", ar: "كرواسون لوز", price: "0.850" },
      { name: "Chocolate Croissant", ar: "كرواسون شوكولاتة", price: "0.850" },
      { name: "Lotus Croissant", ar: "كرواسون لوتس", price: "0.850" },
      { name: "Pistachio Croissant", ar: "كرواسون فستق", price: "0.900", pick: true },
      { name: "Four Cheese Croissant", ar: "كرواسون أربع أجبان", price: "1.700" },
      { name: "Grilled Halloumi Croissant", ar: "كرواسون حلوم مشوي", price: "1.700" },
      { name: "Triple Chocolate Cookie", ar: "كوكيز شوكولاتة ثلاثية", price: "1.100" },
      { name: "Double Chocolate Cookie", ar: "كوكيز شوكولاتة مزدوجة", price: "1.100" },
      { name: "Waffle — Syrup, Chocolate or Lotus", ar: "وافل — سيرب، شوكولاتة أو لوتس", desc: "freshly baked with an ice cream scoop", descAr: "يُخبز طازجاً مع كرة آيس كريم", price: "1.800" },
      { name: "Pistachio Waffle", ar: "وافل فستق", price: "2.000", pick: true },
      { name: "Mix Sauces Waffle", ar: "وافل صوصات مشكّلة", price: "2.000" },
      { name: "Za'atar Waffle", ar: "وافل زعتر", price: "2.000" },
    ],
  },
];

export const COMBOS = [
  {
    id: "morning-chapter",
    en: "The Morning Chapter",
    ar: "فصل الصباح",
    itemsEn: "Spanish Latte + Pistachio Croissant",
    itemsAr: "سبانيش لاتيه + كرواسون فستق",
    price: "2.000",
    was: "2.250",
    tagEn: "Most loved",
    tagAr: "الأكثر طلباً",
  },
  {
    id: "golden-hour",
    en: "Golden Hour",
    ar: "الساعة الذهبية",
    itemsEn: "Iced Spanish Latte + Pistachio Waffle",
    itemsAr: "سبانيش لاتيه مثلج + وافل فستق",
    price: "3.000",
    was: "3.350",
  },
  {
    id: "book-club",
    en: "The Book Club — for two",
    ar: "نادي الكتاب — لشخصين",
    itemsEn: "2 × V60 Yemen + 2 × Butter Croissant",
    itemsAr: "٢ × قهوة V60 يمني + ٢ × كرواسون زبدة",
    price: "3.100",
    was: "3.480",
    tagEn: "For two",
    tagAr: "لشخصين",
  },
  {
    id: "matcha-moment",
    en: "Matcha Moment",
    ar: "لحظة ماتشا",
    itemsEn: "Sipsation Matcha + Triple Chocolate Cookie",
    itemsAr: "ماتشا سبسيشن + كوكيز شوكولاتة ثلاثية",
    price: "2.600",
    was: "2.900",
  },
];

export const HOURS = [
  { days: "Saturday — Thursday", daysAr: "السبت — الخميس", time: "7:00 AM — 11:00 PM", timeAr: "7:00 صباحاً — 11:00 مساءً" },
  { days: "Friday", daysAr: "الجمعة", time: "2:00 PM — 11:00 PM", timeAr: "2:00 مساءً — 11:00 مساءً" },
];

export const REVIEWS = [
  {
    name: "Fatima A.",
    nameAr: "فاطمة أ.",
    text: "The Spanish latte here ruined every other café for me. Cozy corners, kind baristas, and the cookie is non-negotiable.",
    textAr: "السبانيش لاتيه هنا خرّب عليّ كل الكافيهات الثانية. زوايا دافئة، باريستا لطيفون، والكوكيز لا يُفوَّت.",
  },
  {
    name: "Mohammed K.",
    nameAr: "محمد ك.",
    text: "Best V60 in Bahrain, hands down. You can taste the patience in every cup. My Friday ritual, every week.",
    textAr: "أفضل V60 في البحرين بلا منازع. تتذوّق الصبر في كل كوب. طقسي كل جمعة.",
  },
  {
    name: "Sarah R.",
    nameAr: "سارة ر.",
    text: "Came for a quick coffee, stayed for three hours. The energy of this place is something else — warm, unhurried, alive.",
    textAr: "جئت لقهوة سريعة فبقيت ثلاث ساعات. طاقة المكان شيء آخر — دافئ، هادئ، حيّ.",
  },
  {
    name: "Ahmed J.",
    nameAr: "أحمد ج.",
    text: "Open late, always consistent, and the team remembers your order. Sipsation is where good coffee meets good souls.",
    textAr: "مفتوح لوقت متأخر، ثابت دائماً، والفريق يحفظ طلبك. سبسيشن حيث تلتقي القهوة الطيبة بالأرواح الطيبة.",
  },
];
